import { uniqueId } from 'lodash';

function getTempId() {
  return uniqueId('tmp_');
}

export default getTempId;
